import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class GeneratorApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "generators/";
	}
}
